<template>
  <funding-project-base :state="state">
    <div class="container max-w-lg mt-6">
      <template v-if="changeRequests.length">
        <h2 class="text-base flex">
          <icon
            icon="chat-group-alt"
            class="w-6 h-6 icons-primary mr-2"
          />
          Change Requests
        </h2>
        <ol class="list-reset mt-4">
          <li
            v-if="!changeRequests.length"
            class="mb-4"
          >
            <div
              class="relative border border-primary-200 bg-primary-100 text-primary-800 px-6 py-2 uppercase font-bold text-xs text-center"
            >
              There are no change requests for this project.
            </div>
          </li>
          <li
            v-for="request in changeRequests"
            :key="request.id"
            class="mb-6"
          >
            <funding-project-request-item
              :key="request.id"
              :request="request"
              :project-uuid="project.uuid"
              :funding-pot-id="fundingPot.id"
            />
          </li>
        </ol>
      </template>
      <template v-else>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1149 784"
          class="mx-auto block max-w-sm mb-12"
        >
          <path
            fill="#3f3d56"
            d="M435 747c0 21-96 37-214 37S7 768 7 747c0-5 6-10 17-14 31-13 104-22 189-23h8c118 0 214 17 214 37z"
          />
          <path
            d="M213 710a121 121 0 01-189 23c31-13 104-22 189-23z"
            opacity=".1"
          />
          <ellipse cx="112" cy="628.1" fill="#3f3d56" rx="112" ry="120" />
          <path fill="#3f3d56" d="M249 83c16 62 68 101 115 89" />
          <path
            fill="#0072c4"
            d="M364 172c-16-62 14-123 67-137M282 81c15 58 52 99 82 91"
          />
          <path fill="#3f3d56" d="M364 172C343 93 376 16 438 0" />
          <path
            fill="#a8a8a8"
            d="M346 177s12-3 15-7 17-10 19-7 24 17 10 20-32 6-36 5-8-11-8-11z"
          />
          <path
            d="M390 182c-13 3-32 6-36 5s-6-7-7-10h-1s3 10 8 11 23-1 36-5c4-1 5-3 5-5 0 2-2 3-5 4z"
            opacity=".2"
          />
          <path fill="#f2f2f2" d="M343 126h806v467H343z" />
          <path fill="#0072c4" d="M362 268h442v232H362z" opacity=".3" />
          <path
            fill="#3f3d56"
            d="M838 258h177v10H838zM838 276h258v10H838zM838 320h177v10H838zM838 392h177v10H838zM838 338h258v10H838zM838 356h258v10H838zM838 374h258v10H838z"
          />
          <path fill="#0072c4" d="M838 436h93v26h-93z" />
          <path fill="#a0616a" d="M314 408s17-47 29-32-18 39-18 39z" />
          <path
            fill="#575a89"
            d="M236 362l10 3s5 22 3 25-3 1 0 9l12 29c1 3 53-17 53-27 0 0 12 12 17 15l-69 50c-8 5-13 3-21-3s-38-61-38-61z"
          />
          <path
            fill="#2f2e41"
            d="M263 690s-1 10-3 11-16 24 0 29 25 3 29 5 68 5 69-5-31-12-31-12-30-20-35-30-29 2-29 2zM75 709s-22 38-17 42 60 22 68 22c10 1 17-7 9-12s-26-24-26-30v-17z"
          />
          <path
            fill="#2f2e41"
            d="M54 461s-20 24 11 63l51 64s-32 50-33 76-7 21-9 32-10 5-4 14 31 15 38 9 8-15 8-19 12-25 13-31 36-59 36-59 11-32-2-49-22-43-22-43 38 46 65 57c0 0 10 2 9 7s0 7 2 12l29 72c6 14 4 22 11 27s41 1 41-4-5-16-8-23-25-81-23-94-1-31-15-38-84-68-87-68l-111-5z"
          />
          <circle cx="239.5" cy="276.5" r="38.9" fill="#a0616a" />
          <path
            fill="#a0616a"
            d="M208 280s-12 21-27 24 39 46 39 46 13-41 24-43-36-27-36-27z"
          />
          <path
            fill="#575a89"
            d="M246 367c0 12-36 46-36 46l-34 29s-1 10-5 11-8 1-5 7 13 17 5 19a68 68 0 01-8 1 389 389 0 01-32 1l-8-1c-35 0-76-4-72-17 5-23 2-30 14-42s31-54 31-54 39-66 71-66l7-1a15 15 0 0117 6c6 10 17 25 23 30 9 7 10 2 10 2s22 17 22 29z"
          />
          <path fill="#a0616a" d="M164 508s26 41 10 49-26-44-26-44z" />
          <path
            fill="#2f2e41"
            d="M214 272c2 0 2-2 2-3 2-8 8-16 16-17a22 22 0 019 1 34 34 0 0111 5l6 4 9 4c3 1 6 4 9 3 3 0 5-4 5-7 1-8-3-18-7-24-3-5-8-7-14-9a98 98 0 00-19-4c-8-1-17-1-25 1s-16 9-18 18l-1 5-5 12a23 23 0 001 19c2 5 6 9 5 14l7-5a5 5 0 003-6l-1-9v-5c3-6 5 3 7 3z"
          />
          <path
            d="M147 444l9 36h-33l-8-28c-9-33 5-84 13-108s25-30 25-30 10 2 22 11-28 119-28 119z"
            opacity=".1"
          />
          <path
            d="M154 442l9 38a389 389 0 01-32 1l-9-31c-8-33 6-84 13-108s24 3 24 3-7-16 5-8-10 105-10 105z"
            opacity=".1"
          />
          <path
            fill="#575a89"
            d="M157 312s-18 6-26 30-21 75-13 108 26 75 26 75 18-13 24-10l-17-73s39-111 27-119-21-11-21-11z"
          />
          <path fill="#3f3d56" d="M343 244h442v232H343z" />
          <ellipse cx="572.2" cy="364.1" fill="#fff" rx="50" ry="50.1" />
          <path
            fill="#0072c4"
            d="M572 305a60 60 0 1060 60 60 60 0 00-60-60zm-12 92l-31-31 9-8 22 22 47-47 8 9-55 55z"
          />
        </svg>
        <h1 class="text-center text-2xl">
          There are no change requests for this project.
        </h1>
      </template>
    </div>
  </funding-project-base>
</template>
<script>
export default {
  name: "FundingProjectsRequests",
  computed: {
    changeRequests() {
      return this.state.change_requests || [];
    },
    project() {
      return this.state.project;
    },
    fundingPot() {
      return this.state.funding_pot;
    }
  }
};
</script>
